import { render, staticRenderFns } from "./AddCapitulo.vue?vue&type=template&id=81d7a60c&scoped=true"
import script from "./AddCapitulo.vue?vue&type=script&lang=js"
export * from "./AddCapitulo.vue?vue&type=script&lang=js"
import style0 from "./AddCapitulo.vue?vue&type=style&index=0&id=81d7a60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d7a60c",
  null
  
)

export default component.exports